<template>
  <div>
    <!-- Start Sample Area -->
    <section class="sample-text-area"  style="display: none;">
      <div class="container">
        <h3 class="text-heading title_color">公司业绩</h3>
        <p class="sample-text">
         主要有生化试剂和临床化学试剂、环境科学用试剂、光学和电子工业用试剂；军用和民用发光材料；电影和照相用感光材料；印刷用化学品；胶粘剂以及塑料助剂等。建厂以来累计生产近4000个品种。
         北京化工厂还是中国化学试剂科技，并受国家标准局的委托，负责组织制定化学试剂的国家标准。
         汇翔化工有限公司成立于2017年09月25日，注册地位于河南省获嘉县照镜镇楼村工业园区纬三路西段路北，占地面积16500㎡。技术研究依托于河南师范大学化工学院，始终本着"质量为本，诚信务实，勤奋进取，服务至上"的服务理念，并且实际运用于管理之中。新乡市汇翔化工有限公司的诚信、实力和产品质量获得业界的认可。
         经营范围包括溴丙烷、溴化钠、硫酸氢钠水溶液等产品销售！欢迎各界朋友莅临参观、指导和业务洽谈。</p>
      </div>
    </section>
    <!-- End Sample Area -->

    <!-- Start Align Area -->
    <div class="whole-wrap"  style="display: none;">
      <div class="container">
        <div class="section-top-border">
          <h3 class="mb-30 title_color">产品中心</h3>
          <div class="row">
            <div class="col-md-3">
              <img src="static/assets/images/elements/d.jpg" alt="" class="img-fluid">
            </div>
            <div class="col-md-9 mt-sm-20 left-align-p">
              <p>碳酸二甲酯，是一种有机化合物，化学式为C3H6O3，是一种低毒、环保性能优异、用途广泛的化工原料，是一种重要的有机合成中间体，分子结构中含有羰基、甲基和甲氧基等官能团，具有多种反应性能，在生产中具有使用安全、方便、污染少、容易运输等特点。

  中文名：碳酸二甲酯 外文名：Dimethyl carbonate，DMC

  化学式：C3H6O3 分子量：90.078

  熔  点：0.5 ℃ 沸  点：90 ℃

  水溶性：不溶 密  度：1.07 g/cm³

  外  观：无色液体，有芳香气味 闪   点：17 ℃(OC)

  安全性描述：S16；S9 危险性符号：F

  危险性描述：R11UN 危险货物编号：1161</p>
            </div>
          </div>
        </div>
        <div class="section-top-border text-right">
          <h3 class="mb-30 title_color">尿素</h3>
          <div class="row">
            <div class="col-md-9">
              <p class="text-right">尿素是一种酰胺态有机态氮肥，其分子式为CO(NH2)2，是含氮量最高的固体氮肥。
  本品为白色半透明颗粒，属中性肥料，易溶于水，在20℃时，100克水能溶解尿素100克，在常温下吸湿性不大。尿素的扩散性很强，小部分能以分子态被植物吸收。本品适用于各种土壤和作物，可以用于基肥，种肥和根外追肥。尿素除大量用于农业外，它还是树脂、塑料、医药、食品等工业的原料，又是家畜，淡水养殖的饲料。
  本品执行标准为GB/T 2440-2017。昊源公司现已成为浙江，江苏，福建等省的多家胶合板厂生产厂家长期稳定的工业级尿素供应企业，产品质量得到他们的高度认可。</p>
               </div>
            <div class="col-md-3">
              <img src="static/assets/images/elements/d.jpg" alt="" class="img-fluid">
            </div>
          </div>
        </div>
        <div class="section-top-border">
          <h3 class="mb-30 title_color">产品技术</h3>
          <div class="row">
            <div class="col-md-4">
              <div class="single-defination">
                <h4 class="mb-20">碳酸二甲酯</h4>
                <p>碳酸二甲酯，是一种有机化合物，化学式为C3H6O3，是一种低毒、环保性能优异、用途广泛的化工原料，是一种重要的有机合成中间体，分子结构中含有羰基、甲基和甲氧基等官能团，具有多种反应性能，在生产中具有使用安全、方便、污染少、容易运输等特点。</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="single-defination">
                <h4 class="mb-20">乙酸叔丁酯</h4>
                <p>醋酸叔丁酯是一种低毒性溶剂，被美国国家环保局（EPA）列为免除受限制的挥发性溶剂 （VOC-exempt）和非有害空气污染物（non-HAP）。醋酸叔丁酯对多种物质具有优异的溶解能力，如： 硝化纤维、丙烯酸、醇酸树脂、聚酯和聚気酯树脂等。醋酸叔丁酯可以替代多种有害空气污染物（HAP） 和挥发性有溶剂（VOC）,包括甲苯、二甲苯、酯类、酮类和碳氢化合物等。</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="single-defination">
                <h4 class="mb-20">工业清洗剂</h4>
                <p>作为一种溶剂型清洗剂，醋酸叔丁酯与一般的氯化溶剂和烃类溶剂同样具有广泛的溶解能力，而且作为非卤溶剂，不会对臭氧层造成破坏，可用于金属脱脂和特殊设备的清洁，例如航空、航天工业机械，精细机械设备等的清洗等。此外还能有效清除甲苯、被清洗矿物油和丙酮污染的土壤、锂基润滑脂等。</p>
              </div>
            </div>
          </div>
        </div>
        <div class="section-top-border">
          <h3 class="mb-30 title_color">产品介绍及应用</h3>
          <div class="row">
            <div class="col-lg-12">
              <blockquote class="generic-blockquote">
                醋酸叔丁酯是一种低毒性溶剂，被美国国家环保局（EPA）列为免除受限制的挥发性溶剂 （VOC-exempt）和非有害空气污染物（non-HAP）。醋酸叔丁酯对多种物质具有优异的溶解能力，如： 硝化纤维、丙烯酸、醇酸树脂、聚酯和聚気酯树脂等。醋酸叔丁酯可以替代多种有害空气污染物（HAP） 和挥发性有溶剂（VOC）,包括甲苯、二甲苯、酯类、酮类和碳氢化合物等。

  ♦涂料、油墨、粘合剂：醋酸叔丁酯在装饰和工业涂料，以及油墨、压敏胶、粘合剂等配方中，可替代VOC和HAP溶剂，它比丙酮和醋酸甲酯更加不易挥发和不易燃。醋酸叔丁酯在多种涂料体系中（例如，2K聚氨酯、醇酸树脂、丙烯酸树脂、硝基纤维、喷漆和烤漆等）与其他溶剂有着类似的挥发速度和溶解能力，例如甲乙酮、甲基异丁基酮、乙基、丙基醋酸酯和甲苯等。由于其优越的耐胺能力，也可以用于取代环氧聚酰胺涂料中的甲苯溶剂。

  ♦工业清洗剂：作为一种溶剂型清洗剂，醋酸叔丁酯与一般的氯化溶剂和烃类溶剂同样具有广泛的溶解能力，而且作为非卤溶剂，不会对臭氧层造成破坏，可用于金属脱脂和特殊设备的清洁，例如航空、航天工业机械，精细机械设备等的清洗等。此外还能有效清除甲苯、被清洗矿物油和丙酮污染的土壤、锂基润滑脂等。

  ♦电子行业：醋酸叔丁酯在半导体加工过程中也有一定的应用，在光刻胶配方中可用来替代其他溶剂，也可用于清洗电路板，除油和去除助焊剂。

  ♦其他应用：农产品；纺织品：制药中间体等等。
              </blockquote>
            </div>
          </div>
        </div>
      
        <div class="section-top-border">
          <h3 class="title_color">图片中心</h3>
          <div class="row gallery-item">
            <div class="col-md-4">
              <a href="static/assets/images/elements/g1.jpg" class="img-gal"><div class="single-gallery-image" style="background: url(static/assets/images/elements/g1.jpg);"></div></a>
            </div>
            <div class="col-md-4">
              <a href="static/assets/images/elements/g2.jpg" class="img-gal"><div class="single-gallery-image" style="background: url(static/assets/images/elements/g2.jpg);"></div></a>
            </div>
            <div class="col-md-4">
              <a href="static/assets/images/elements/g3.jpg" class="img-gal"><div class="single-gallery-image" style="background: url(static/assets/images/elements/g3.jpg);"></div></a>
            </div>
            <div class="col-md-6">
              <a href="static/assets/images/elements/g4.jpg" class="img-gal"><div class="single-gallery-image" style="background: url(static/assets/images/elements/g4.jpg);"></div></a>
            </div>
            <div class="col-md-6">
              <a href="static/assets/images/elements/g5.jpg" class="img-gal"><div class="single-gallery-image" style="background: url(static/assets/images/elements/g5.jpg);"></div></a>
            </div>
            <div class="col-md-4">
              <a href="static/assets/images/elements/g6.jpg" class="img-gal"><div class="single-gallery-image" style="background: url(static/assets/images/elements/g6.jpg);"></div></a>
            </div>
            <div class="col-md-4">
              <a href="static/assets/images/elements/g7.jpg" class="img-gal"><div class="single-gallery-image" style="background: url(static/assets/images/elements/g7.jpg);"></div></a>
            </div>
            <div class="col-md-4">
              <a href="static/assets/images/elements/g8.jpg" class="img-gal"><div class="single-gallery-image" style="background: url(static/assets/images/elements/g8.jpg);"></div></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Align Area -->
  </div>
</template>

<script>
  export default {}
</script>




// WEBPACK FOOTER //
// Elements.vue?3477cec8